<div [style.background-image]="'url(assets/images/404-Dark.svg)'" class="relative w-full h-screen bg-center bg-cover">
    <div class="absolute inset-0 dark:bg-opacity-50 bg-opacity-50"></div>
    <div class="relative z-10 flex flex-col items-center justify-center h-full px-4">
        <span class="icon-lock scale-[2.0] mb-2"></span>
        <h1 class="text-4xl font-bold mb-4">{{ 'not-found.title' | translate }}</h1>
        <p class="text-lg mb-8 text-center">{{ 'not-found.information' | translate }}</p>
        <div class="flex space-x-4">
            <a routerLink="/">
                <button type="button" class="btn btn-primary" color="primary">
                    <i aria-hidden="true" class="icon element-return"></i>
                    {{ 'not-found.back-to-home' | translate }}
                </button>
            </a>
        </div>
    </div>
</div>
